var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMicrosoftTeams(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 8.6895C11.875 8.37775 12.1278 8.125 12.4395 8.125H19.4355C19.7473 8.125 20 8.37775 20 8.6895V12.8125C20 15.0562 18.1812 16.875 15.9375 16.875C13.6938 16.875 11.875 15.0562 11.875 12.8125V8.6895Z",
    fill: "url(#paint0_linear_399_3707)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 7.64112C5.625 7.218 5.96801 6.875 6.39112 6.875H14.8589C15.282 6.875 15.625 7.218 15.625 7.64112V13.75C15.625 16.5114 13.3864 18.75 10.625 18.75C7.86356 18.75 5.625 16.5114 5.625 13.75V7.64112Z",
    fill: "url(#paint1_linear_399_3707)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 6.875C17.9105 6.875 18.75 6.03553 18.75 5C18.75 3.96447 17.9105 3.125 16.875 3.125C15.8395 3.125 15 3.96447 15 5C15 6.03553 15.8395 6.875 16.875 6.875Z",
    fill: "#34439E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 6.875C17.9105 6.875 18.75 6.03553 18.75 5C18.75 3.96447 17.9105 3.125 16.875 3.125C15.8395 3.125 15 3.96447 15 5C15 6.03553 15.8395 6.875 16.875 6.875Z",
    fill: "url(#paint2_linear_399_3707)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 6.25C12.6307 6.25 13.75 5.13071 13.75 3.75C13.75 2.36929 12.6307 1.25 11.25 1.25C9.86929 1.25 8.75 2.36929 8.75 3.75C8.75 5.13071 9.86929 6.25 11.25 6.25Z",
    fill: "url(#paint3_linear_399_3707)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_399_3707",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 0,
    width: 11,
    height: 19
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 6.25C12.3509 6.25 13.75 4.85092 13.75 3.125C13.75 1.39908 12.3509 0 10.625 0C8.89906 0 7.5 1.39908 7.5 3.125C7.5 4.85092 8.89906 6.25 10.625 6.25Z",
    fill: "url(#paint4_linear_399_3707)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.39112 6.875C5.96802 6.875 5.625 7.218 5.625 7.64112V13.75C5.625 16.5114 7.86356 18.75 10.625 18.75C13.3864 18.75 15.625 16.5114 15.625 13.75V7.64112C15.625 7.218 15.282 6.875 14.8589 6.875H6.39112Z",
    fill: "url(#paint5_linear_399_3707)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_399_3707)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.375 7.5C4.375 6.46444 5.21447 5.625 6.25 5.625H10.625C11.6606 5.625 12.5 6.46444 12.5 7.5V15C12.5 16.0356 11.6606 16.875 10.625 16.875H4.375V7.5Z",
    fill: "black",
    fillOpacity: 0.3
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10 4.375H1.25C0.559644 4.375 0 4.93464 0 5.625V14.375C0 15.0654 0.559644 15.625 1.25 15.625H10C10.6904 15.625 11.25 15.0654 11.25 14.375V5.625C11.25 4.93464 10.6904 4.375 10 4.375Z",
    fill: "url(#paint6_linear_399_3707)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 6.875H3.125V8.02169H4.99684V13.125H6.25319V8.02169H8.125V6.875Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_399_3707",
    x1: 11.875,
    y1: 8.5855,
    x2: 20.0994,
    y2: 13.9597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#364088"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E7EE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_399_3707",
    x1: 5.625,
    y1: 12.1274,
    x2: 15.625,
    y2: 12.1274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7084EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_399_3707",
    x1: 15,
    y1: 3.32237,
    x2: 18.6227,
    y2: 5.87168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#364088"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E7EE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_399_3707",
    x1: 9.46431,
    y1: 1.96429,
    x2: 12.6786,
    y2: 5.71429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4858AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E60CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_399_3707",
    x1: 8.39287,
    y1: 0.892856,
    x2: 12.4107,
    y2: 5.58036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4858AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E60CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_399_3707",
    x1: 8.39287,
    y1: 0.892856,
    x2: 12.4107,
    y2: 5.58036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4858AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E60CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_399_3707",
    x1: -3.25962e-8,
    y1: 10,
    x2: 11.25,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A3887"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C56B9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftTeams);
export default __webpack_public_path__ + "static/media/microsoft-teams.0d48e9ed3b2530a40adcab69bcee1dde.svg";
export { ForwardRef as ReactComponent };